export default __webpack_public_path__ + "static/media/gear.11371e6b.svg";